import React from "react";
import Paper from "@material-ui/core/Paper";

import Linkedin from "./images/linkedin.png";
import Email from "./images/email.jpg";

export default class Appbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Paper
        elevation={0}
        square={true}
        style={{
          display: "flex",
          height: 145,
          flexDirection: "column",
          marginTop: 55
        }}
      >
        <b>Contact</b>
        <p>
          <div>
            <a href="mailto:tommy@luong.co" style={styles.links}>
              tommy@luong.co
            </a>
          </div>
        </p>
        <a href="https://www.linkedin.com/in/toluong/" style={styles.links}>
          LinkedIn
        </a>
      </Paper>
    );
  }
}

const styles = {
  links: {
    textDecoration: "none",
    color: "black"
  }
};



// WEBPACK FOOTER //
// ./src/contact.js